export default {
  apiKey: 'AIzaSyBM_XliM3hUX5vkCeLg6bK6pStIW56WhDk',
  authDomain: 'ecgo-dev.firebaseapp.com',
  projectId: 'ecgo-dev',
  storageBucket: 'ecgo-dev.appspot.com',
  messagingSenderId: '22967651432',
  appId: '1:22967651432:web:c595cbe64157a46987ffdd',
  measurementId: 'G-QZ82044G01',
};
